import { Private_Routes } from '@common/url';

export enum HUB_TYPE {
  PACKAGE = 'package',
  TEMPLATE = 'template'
}

export const HUB_URL = {
  PACKAGE: Private_Routes.PackageHubList.getUrl(undefined, { type: HUB_TYPE.PACKAGE }),
  TEMPLATE: Private_Routes.PackageHubList.getUrl(undefined, { type: HUB_TYPE.TEMPLATE })
};

export enum HUB_TAB {
  PACKAGE = 'Package Hub',
  TEMPLATE = 'Template Hub'
}
